/**
 * Print-only cover page rendered at the very top of /report when the user
 * triggers Print / Save-as-PDF. Hidden on screen via `print-only` class.
 */
export default function PrintCover({ input, health, report }) {
  const today = new Date().toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const score = Math.round(health?.overall_score ?? 0);
  const ratingColor =
    health?.rating === "Strong" || health?.rating === "Healthy"
      ? "#2C5C43"
      : health?.rating === "Watchlist"
        ? "#9c6b1d"
        : "#A84632";
  return (
    <div className="print-only" data-testid="print-cover">
      <div className="flex items-center justify-between border-b border-[#E5E0D8] pb-6 mb-10">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-md bg-[#1F382E] flex items-center justify-center">
            <svg viewBox="0 0 100 100" className="h-5 w-5">
              <path d="M22 70 L42 50 L58 60 L78 32" stroke="#D4C9B6" strokeWidth="6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              <circle cx="78" cy="32" r="5" fill="#C26D5C" />
            </svg>
          </div>
          <div>
            <p className="font-serif-display text-2xl text-[#1F382E] leading-none">CFO Grade</p>
            <p className="text-[10px] uppercase tracking-[0.22em] text-[#5C665D] mt-1">
              Financial Health Report
            </p>
          </div>
        </div>
        <div className="text-right text-[10px] uppercase tracking-[0.18em] text-[#5C665D]">
          <p>Generated {today}</p>
          <p className="mt-1">Report ID · {(report.id || "").slice(0, 8)}</p>
        </div>
      </div>

      <div className="mb-10">
        <p className="text-[10px] uppercase tracking-[0.22em] text-[#5C665D]">
          {input.period || "Latest period"} · {input.industry || "—"} · {input.currency || "USD"}
          {report.region && report.region !== "GLOBAL" ? ` · ${report.region}` : ""}
        </p>
        <h1 className="font-serif-display text-5xl text-[#1F382E] leading-tight mt-2">
          {input.company_name || "Your Business"}
        </h1>
        <div className="flex items-baseline gap-3 mt-6">
          <span className="font-serif-display text-7xl tabular-nums leading-none" style={{ color: ratingColor }}>
            {score}
          </span>
          <span className="text-base text-[#5C665D]">/ 100 CFO Grade</span>
          <span
            className="ml-3 inline-flex items-center px-3 py-1 rounded-full text-xs"
            style={{ background: `${ratingColor}1a`, color: ratingColor }}
          >
            {health?.rating} · {health?.risk_level} risk
          </span>
        </div>
        <p className="text-[#5C665D] text-sm leading-relaxed mt-4 max-w-3xl">
          This report computes 24+ ratios across profitability, liquidity, solvency and efficiency,
          benchmarks them against typical operators in your industry{report.region && report.region !== "GLOBAL" ? ` (${report.region} regional set)` : ""},
          and provides a prescriptive narrative for {report.audience === "analyst" ? "credit underwriting review" : "operator improvement"}.
        </p>
      </div>
    </div>
  );
}
